// Account-based, independently salted assignment: the experiment id is the
// salt, so two experiments over the same population split it independently.
// quentin's helpers/earnLoop carries the same function; keep them identical.
export const experimentBucket = (
  experiment: string,
  userId: string,
): number => {
  let hash = 2166136261;
  for (const char of `${experiment}:${userId}`) {
    hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  }
  // Mix high and low bits so adjacent ObjectIds do not cluster together.
  hash = Math.imul(hash ^ (hash >>> 16), 0x85ebca6b);
  hash = Math.imul(hash ^ (hash >>> 13), 0xc2b2ae35);
  hash ^= hash >>> 16;
  return (hash >>> 0) / 4294967296;
};
